function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyReportsIconOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 6.55,
    y: 22.61,
    width: 6.59,
    height: 11.86,
    style: {
      fill: "#62a3ef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.71,
    y: 16.37,
    width: 6.59,
    height: 18.1,
    style: {
      fill: "#62a3ef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.86,
    y: 6.68,
    width: 6.59,
    height: 27.79,
    style: {
      fill: "#62a3ef"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyReportsIconOnboarding);
export default __webpack_public_path__ + "static/media/daily_reports_icon_onboarding.8194353d80a7b4b30b6a216ff7d97023.svg";
export { ForwardRef as ReactComponent };